// extracted by mini-css-extract-plugin
module.exports = {"Assistant":"Assistant_Assistant__KbUaX"};